export interface IGetBySchoolRequest {
    ano: number;
    idSchool: number;
}